import 'dayjs/locale/bg'
import { Dayjs } from 'dayjs'

const bg = {
  calendar: {
    sameDay: '[Днес в] LT',
    nextDay: '[Утре в] LT',
    nextWeek: 'dddd [в] LT',
    lastDay: '[Вчера в] LT',
    lastWeek: function (now: Dayjs) {
      switch (now.day()) {
        case 0:
        case 3:
        case 6:
          return now.format('[Миналата] dddd [в] LT')
        case 1:
        case 2:
        case 4:
        case 5:
          return now.format('[Миналия] dddd [в] LT')
      }
    },
    sameElse: 'L'
  }
}

export default bg
